import { useParams } from 'react-router';

import { useAppSelector } from '../../../../../../../../store/hooks';
import { getActiveMandantIdSelector } from '../../../../../../../shared/store/selectors/get-active-mandant-id/get-active-mandant-id.selector';
import { getIsAppLoadingSelector } from '../../../../../../../shared/store/selectors/get-is-app-loading/get-is-app-loading.selector';
import { getReviewsFilters } from '../../selectors/get-reviews-filters/get-reviews-filters.selector';
import { getReviewsSelector } from '../../selectors/get-reviews-selector/get-reviews.selector';
import { ReviewsTableConfigModel } from './models/reviews-table-config.model';

export const useGetReviewsTableSelectors = (): ReviewsTableConfigModel => {
  const reviews = useAppSelector(getReviewsSelector);
  const reviewsFilters = useAppSelector(getReviewsFilters);
  const activeMandantId = useAppSelector(getActiveMandantIdSelector);
  const { id: appId } = useParams();
  const isLoading = useAppSelector(getIsAppLoadingSelector);

  return {
    reviews,
    reviewsFilters,
    activeMandantId,
    appId,
    isLoading,
  };
};
